import React, { useEffect, useState } from "react";
import "./booking.css";
import Button from "./btn";
import SecTitle from "./secTitle";
import { useTranslation } from "react-i18next";

const Booking = () => {
      const { t, i18n } = useTranslation();
  
      useEffect(() => {
        const lang = i18n.language;
        const dir = lang === "ar" ? "rtl" : "ltr";
        document.documentElement.lang = lang;
        document.documentElement.dir = dir;
      }, [i18n.language]);
  
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    event: "",
    tickets: 1,
  });

  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState("");

  const events = [t("Midnight Pages Book Club"), t("Poetry Under Stars"), t("Creative Writing Workshop")];

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleTickets = (type) => {
    setFormData((prev) => ({
      ...prev,
      tickets:
        type === "inc"
          ? prev.tickets + 1
          : prev.tickets > 1
          ? prev.tickets - 1
          : 1,
    }));
  };

  const validate = () => {
    let newErrors = {};

    if (!formData.name.trim()) newErrors.name = t("Name is required");
    if (!formData.email.trim()) newErrors.email = t("Email is required");
    if (!formData.event) newErrors.event = t("Please select an event");

    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const validationErrors = validate();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setSuccess("");
    } else {
      setErrors({});
      setSuccess(t("Booking confirmed successfully!"));

      setFormData({
        name: "",
        email: "",
        event: "",
        tickets: 1,
      });
    }
  };

  return (
    <div id="book" className="booking-container">
      <SecTitle secTitle={t("Book Your Spot")} />
      <form onSubmit={handleSubmit}>
        <div className="formCont body">
            <label className="body">{t("Name")}</label>
            <input className="body" type="text" name="name" placeholder={t("Your name")} value={formData.name} onChange={handleChange} />
            {errors.name && <p className="error body">{errors.name}</p>}
        </div>
        <div className="formCont">
            <label className="body">{t("Email")}</label>
            <input className="body" type="email" name="email" placeholder={t("your@email.com")} value={formData.email} onChange={handleChange} />
            {errors.email && <p className="error body">{errors.email}</p>}
        </div>
        <div className="formCont">
            <label className="body">{t("Select Event")}</label>
            <select className="body" name="event" value={formData.event} onChange={handleChange}>
            <option className="body" value="">{t("Choose an event")}</option>
            {events.map((event, index) => (
                <option key={index} value={event}>
                  {event}
                </option>
            ))}
            </select>
            {errors.event && <p className="error body">{errors.event}</p>}
        </div>
        <div className="formCont">
            <label className="body">{t("Number of Tickets")}</label>
            <div className="tickets">
            <button className="numeric" type="button" onClick={() => handleTickets("dec")}>
                -
            </button>
            <input type="text" value={formData.tickets} readOnly />
            <button className="numeric" type="button" onClick={() => handleTickets("inc")}>
                +
            </button>
            </div>
        </div>
        <Button btnType="submit" btnText={t("Book Now")} />
        {success && <p className="success body">{success}</p>}
      </form>
    </div>
  );
};

export default Booking;